import api from '../token';

export const AddMoeda = async (dados) => {
  try {
    const response = await api.post('/addMoeda', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};



